<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
  >
    <path
      data-name="合体 268"
      d="m16295 19811 8.24 7.326a2.229 2.229 0 0 1 0 3.35l-8.24 7.33zm-7 18v-18h4v18zm-7 0v-18h4v18zm-7 0v-18h4v18z"
      transform="translate(-16271 -19802.004)"
      :style="{ fill: colorSVG }"
    />
  </svg>
</template>

<script>
export default {
  name: 'NextTenFrameSVG',
  props: {
    color: {
      type: String,
      default: '#989898',
    },
  },
  computed: {
    colorSVG() {
      return this.color || '#989898';
    },
  },
};
</script>
